// Gen AI Events
export var ENGAGE_GEN_AI_POPOVER_OPENED = 'engage_gen_ai_popover_opened';
export var ENGAGE_GEN_AI_POPOVER_CLOSED = 'engage_gen_ai_popover_closed';
export var ENGAGE_GEN_AI_SUGGESTION_CLICKED = 'engage_gen_ai_suggestion_clicked';
export var ENGAGE_GEN_AI_PROMPT_SUBMITTED = 'engage_gen_ai_prompt_submitted';
export var ENGAGE_GEN_AI_TEXT_REQUEST_FAILED = 'engage_gen_ai_text_request_failed';
export var ENGAGE_GEN_AI_TEXT_APPLY_FAILED = 'engage_gen_ai_text_apply_failed';
export var ENGAGE_GEN_AI_TEXT_RESULT_APPLIED = 'engage_gen_ai_text_result_applied';
export var ENGAGE_GEN_AI_UNDO_CLICKED = 'engage_gen_ai_undo_clicked';
export var ENGAGE_GEN_AI_RESULT_EDITED_AFTER_APPLY = 'engage_gen_ai_result_edited_after_apply';
export var ENGAGE_GEN_AI_IMAGE_PROMPT_SUBMITTED = 'engage_gen_ai_image_prompt_submitted';
export var ENGAGE_GEN_AI_IMAGE_REQUEST_FAILED = 'engage_gen_ai_image_request_failed';
export var ENGAGE_GEN_AI_IMAGE_SET = 'engage_gen_ai_image_set';
export var ENGAGE_GEN_AI_IMAGE_UNDO_CLICKED = 'engage_gen_ai_image_undo_clicked';
// Campaign Builder Events
export var ENGAGE_CAMPAIGN_BUILDER_STARTED = 'engage_campaign_builder_started';
export var ENGAGE_CAMPAIGN_BUILDER_STEP_NAVIGATION = 'engage_campaign_builder_step_navigation';
export var ENGAGE_CAMPAIGN_TEST_SENT = 'engage_campaign_test_sent';
export var ENGAGE_CAMPAIGN_BUILDER_CLOSED = 'engage_campaign_builder_closed';
export var ENGAGE_CAMPAIGN_SAVED = 'engage_campaign_saved';
export var ENGAGE_CAMPAIGN_SENT_OR_SCHEDULED = 'engage_campaign_sent_or_scheduled';
export var ENGAGE_CONTENT_PREVIEW_CHANNEL_SWITCHED = 'engage_content_preview_channel_switched';
export var ENGAGE_REVIEW_PREVIEW_CHANNEL_SWITCHED = 'engage_review_preview_channel_switched';
// Campaigns List Events
export var ENGAGE_CAMPAIGNS_LIST_VIEWED = 'engage_campaigns_list_viewed';
export var ENGAGE_CAMPAIGNS_LIST_SEARCHED = 'engage_campaigns_list_searched';
export var ENGAGE_CAMPAIGNS_LIST_FILTERED = 'engage_campaigns_list_filtered';
export var ENGAGE_CAMPAIGN_ACTION_CLICKED = 'engage_campaign_action_clicked';
